module.exports = __webpack_public_path__ + "img/add.fd029ab4.svg";